import React, { useEffect, useState } from 'react'
import { Button, Drawer, notification ,Upload} from 'antd'
import {
    CloudUploadOutlined, UploadOutlined, PlusOutlined
} from '@ant-design/icons'
import PropTypes from 'prop-types'
import { useData } from '../../../data'
import { trackPromise, usePromiseTracker } from 'react-promise-tracker'
import { Form, Input, Select, } from 'antd'
import { CTAButton } from '../components'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
    error: {
        fontSize: 18,
        color: 'red'
    }
}))

const { Option } = Select

/**
 * Drawer to add a new cookie 
 */
const AddNewUpload = ({ close, visible }) => {

    const [error, setError] = useState(null)
    const [form] = Form.useForm()

    const data = useData()
    const classes = useStyles()
    const [accountKeys, setNewAccountKeys] = useState([])
    const tools = data.tools()
    const tlr = data.tlr()

    useEffect(() => {
        // eslint-disable-next-line
    }, [])


    const { promiseInProgress } = usePromiseTracker()
    function handleChange(value) {

        form.setFieldsValue({ "type": value })
    }


    // extract file details
    const normFile = (e) => {

        if (Array.isArray(e)) {
          return e[0];
        }
        return e.fileList[0];
      };


    const createUpload = (vals) => {
        setError(null)


        const {parameters=[]} = vals
        const params = {}

        for(let param of parameters){
            const {param_key, param_value} = param

            params[param_key] = param_value
        }

        trackPromise(
            tlr.uploadtlrdata({...vals, parameters: params})
                .then(tlrjob => {
                   form.resetFields()
                   close(tlrjob)
                })
                .catch(err => {
                    setError("An error occured")
                })
        )
    }

    return (
        <Drawer
            visible={visible}
            title="Upload data to TLR"
            onClose={close}
            placement="right"
            closable={true}
            width={350}
        >
            <Form
                layout="vertical"
                onFinish={createUpload}
                form={form}
            >
                <Form.Item label="Type" name="type" rules={[{ required: true, message: 'Type is required' }]}>
                    <Select
                    >
                        <Option value="company">Company</Option>
                        <Option value="contact">Contact</Option>
                    </Select>
                </Form.Item>
                <Form.Item
                    label="Input file"
                    name="input_file"
                    getValueFromEvent={normFile}

                >
                    <Upload
                        name="input_file"
                        accept=".csv"
                        beforeUpload={() => {
                            return false
                        }}
                        multiple={false}
                    >
                            <Button icon={<UploadOutlined/>} > Upload input file </Button>
                    </Upload>
                </Form.Item>
                <Form.Item >
                    <CTAButton type="submit" loading={promiseInProgress}>Submit</CTAButton>
                </Form.Item>
                {
                    error && (
                        <Form.Item >
                            <p className={classes.error}>{error}</p>
                        </Form.Item>
                    )
                }
            </Form>
        </Drawer>
    )
}


AddNewUpload.propTypes = {
    /** Control visibility of the drawer */
    visible: PropTypes.bool,
    close: PropTypes.func,

}
export default AddNewUpload